<template>
    <div id="admin">
        <div class="main">
            <h1 style="margin-bottom:30px">PCGA 后台管理系统</h1>
            <el-form :inline="true" v-if="!success">
                <el-form-item label="密码">
                    <el-input v-model="pw" placeholder="请输入密码"  show-password></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="goSystem">进入系统</el-button>
                </el-form-item>
            </el-form>
            <div v-else>
                <el-form :inline="true">
                    <el-button type="primary" plain @click="reload">重新加载所有</el-button><el-button type="danger" plain @click="logout">退出登录</el-button>
                </el-form>
                <el-row :gutter="20" class="row">
                    <el-col :span="12">
                        <div class="table-title">PCGA任务记录（{{task_table_data.total}}）</div>
                        <div class="table">
                            <ATab
                                :table_data="task_table_data"
                                :loadData="loadTaskFullData"
                                :restartTaskByID="restartTask"
                            ></ATab>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="table-title">PCGA Common任务记录（GEC,EMIC）（{{common_task_table_data.total}}）</div>
                        <div class="table">
                            <ATab
                                :table_data="common_task_table_data"
                                :loadData="loadCommonTaskFullData"
                                :restartTaskByID="restartTaskCommon"
                            ></ATab>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" class="row">
                    <el-col :span="8">
                        <div class="table-title">查询记录（{{action_table_data.total}}）</div>
                        <div class="table">
                        <Tab
                            :table_data="action_table_data"
                            :loadData="loadActionFullData"
                        ></Tab>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="table-title">下载记录（{{download_table_data.total}}）</div>
                        <div class="table">
                        <Tab
                            :table_data="download_table_data"
                            :loadData="loadDownloadFullData"
                        ></Tab>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="table-title">反馈记录（{{feedback_table_data.total}}）</div>
                        <div class="table">
                        <Tab
                            :table_data="feedback_table_data"
                            :loadData="loadFeedbackFullData"
                        ></Tab>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import Navi from "@/components/navigate.vue";
import Footer from "@/components/footer.vue";
// import SPR from "@/components/show_phenotype_result.vue";
import axios from "axios/dist/axios.min";
import { api_dir,getTime } from "@/bus.js";
import Box from "@/components/plot/box.vue";
import Pie from "@/components/plot/pie.vue";
import Bar from "@/components/plot/bar.vue";
import Tab from "@/components/plot/rt_table.vue";
import ATab from "@/components/plot/rt_admin_table.vue";

export default {
    name: "browse",
    components: { Navi, Footer, Box, Pie, Tab, Bar, ATab },
    data: function () {
        return ({
            pw: '',
            success: false,
            task_table_data: {
                loading:false,
                sort_key: '-submit_time',
                total:0,
                sortConfig: { remote: true},
                tableColumn: [
                    { field: 'task_id', title: '任务号', width: '14%', msg: { message: '' },},
                    { field: 'raw_file_name', title: 'GWAS文件名', width: '20%', msg: { message: '' }, },
                    { field: 'time_str', title: '提交时间', width: '17%', msg: { message: '' }, sort: true },
                    { field: 'status', title: '状态', width: '7%', msg: { message: '' },  },
                    { field: 'ip', title: 'IP', width: '13%', msg: { message: '' },  },
                    // { field: 'addr', title: '地址', width: '16%', msg: { message: '' }, sort: true },
                    { field: 'email', title: '邮箱', width: '14%', msg: { message: '' }, },
                ],
                tableData: [],
            },
            common_task_table_data: {
                loading:false,
                sort_key: '-submit_time',
                total:0,
                sortConfig: { remote: true},
                tableColumn: [
                    { field: 'func', title: '功能', width: '7%', msg: { message: '' },},
                    { field: 'task_id', title: '任务号', width: '14%', msg: { message: '' },},
                    { field: 'raw_file_name', title: 'GWAS文件名', width: '14%', msg: { message: '' },},
                    { field: 'time_str', title: '提交时间', width: '16%', msg: { message: '' }, sort: true },
                    { field: 'status', title: '状态', width: '7%', msg: { message: '' }, },
                    { field: 'ip', title: 'IP', width: '13%', msg: { message: '' }, sort: true },
                    // { field: 'addr', title: '地址', width: '16%', msg: { message: '' }, sort: true },
                    { field: 'email', title: '邮箱', width: '14%', msg: { message: '' }, sort: true },
                ],
                tableData: [],
            },
            action_table_data: {
                loading:false,
                sort_key: '-time',
                sortConfig: { remote: true},
                tableColumn: [
                    { field: 'type', title: '检索类型', width: '20%', msg: { message: '' }, sort: true },
                    { field: 'value', title: '字段', width: '30%', msg: { message: '' }, sort: true },
                    { field: 'time_str', title: '时间', width: '30%', msg: { message: '' }, sort: true },
                    { field: 'ip', title: 'IP', width: '20%', msg: { message: '' }, sort: true },
                    // { field: 'address', title: '地址', width: '25%', msg: { message: '' }, sort: true },
                ],
                tableData: [],
                total:0
            },
            download_table_data: {
                loading:false,
                sort_key: '-time',
                sortConfig: { remote: true},
                tableColumn: [
                    { field: 'file_name', title: '文件名', width: '40%', msg: { message: '' }, sort: true },
                    { field: 'time_str', title: '时间', width: '30%', msg: { message: '' }, sort: true },
                    { field: 'ip', title: 'IP', width: '30%', msg: { message: '' }, sort: true },
                    // { field: 'addr', title: '地址', width: '25%', msg: { message: '' }, sort: true },
                    // { field: 'address', title: '地址', width: '25%', msg: { message: '' }, sort: true },
                ],
                tableData: [],
                total:0
            },
            feedback_table_data: {
                loading:false,
                sort_key: '-time',
                total:0,
                sortConfig: { remote: true},
                tableColumn: [
                    { field: 'type', title: '反馈类型', width: '20%', msg: { message: '' } },
                    { field: 'desc', title: '字段', width: '35%', msg: { message: '' }, sort: true },
                    { field: 'time_str', title: '时间', width: '25%', msg: { message: '' }, sort: true },
                    { field: 'ip', title: 'IP', width: '20%', msg: { message: '' }, sort: true },
                    // { field: 'addr', title: '地址', width: '20%', msg: { message: '' }, sort: true },
                ],
                tableData: [],
                total:0
            },
        });
    },
    mounted:para=>{
        
    },
    methods: {
        goSystem() {
            var para = { admin: this.pw };
            let _this = this;
            axios.get(api_dir + "/api.php", {
                params: para,
            }).then(response => {
                var res = JSON.parse(JSON.stringify(response.data));
                if (('pw' in res) && (res['pw'] == 0)) {
                    _this.success = true;
                    _this.$message.success('登录成功！');
                    _this.loadActionFullData();
                    _this.loadDownloadFullData();
                    _this.loadFeedbackFullData();
                    _this.loadTaskFullData();
                } else {
                    _this.$message.error('密码错误！');
                }
            })
        },
        reload(){
            let _this=this
            _this.loadActionFullData({'sort':'-time'});
            _this.loadDownloadFullData({'sort':'-time'});
            _this.loadFeedbackFullData({'sort':'-time'});
            _this.loadTaskFullData({'sort':'-submit_time'});
            _this.loadCommonTaskFullData({'sort':'-submit_time'});
        },
        logout(){
            this.success=false;
            this.pw='';
        },
        restartTaskCommon(task_id){
            var _this = this
            var para = {
                'action': 'restart_common_task',
                'admin':_this.pw,
                'task_id':task_id
            }
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                })
                .then(function (response) {
                    _this.$message.success('重启任务成功！');
                    _this.loadCommonTaskFullData({'sort':'-submit_time'});
                })
                .catch(function (error) {
                    console.log(error);
                    _this.$message.error('重启任务失败！');
                })
        },
        restartTask(task_id){
            var _this = this
            var para = {
                'action': 'restart_task',
                'admin':_this.pw,
                'task_id':task_id
            }
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                })
                .then(function (response) {
                    _this.$message.success('重启任务成功！');
                    _this.loadTaskFullData({'sort':'-submit_time'});
                })
                .catch(function (error) {
                    console.log(error);
                    _this.$message.error('重启任务失败！');
                })
        },
        loadActionFullData(listQuery) {
            var _this = this
            _this.action_table_data.loading=true;
            var para = {
                'action': 'get_action',
                'admin':_this.pw,
            }
            for(var k in listQuery){
                para[k]=listQuery[k]
            }
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                })
                .then(function (response) {
                    var res = JSON.parse(JSON.stringify(response.data));
                    var arr=res.items
                    for(var ele of arr){
                        ele['time_str']=getTime(ele['time'])
                    }
                    //do table
                    _this.action_table_data.tableData = arr ;
                    _this.action_table_data.total = res.total ;
                    
                })
                .catch(function (error) {
                    console.log(error);
                }).then(function(){
                    _this.action_table_data.loading=false;
                })
        },
        loadDownloadFullData(listQuery) {
            var _this = this
            _this.download_table_data.loading=true;
            var para = {
                'action': 'get_download',
                'admin':_this.pw,
            }
            for(var k in listQuery){
                para[k]=listQuery[k]
            }
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                })
                .then(function (response) {
                    var res = JSON.parse(JSON.stringify(response.data));
                    var arr=res.items
                    for(var ele of arr){
                        ele['time_str']=getTime(ele['time'])
                    }
                    //do table
                    _this.download_table_data.tableData = arr ;
                    _this.download_table_data.total = res.total ;
                })
                .catch(function (error) {
                    console.log(error);
                }).then(function(){ 
                    _this.download_table_data.loading=false;
                })
        },
        loadFeedbackFullData(listQuery) {
            var _this = this
            _this.feedback_table_data.loading=true;
            var para = {
                'action': 'get_feedback',
                'admin':_this.pw,
            }
            for(var k in listQuery){
                para[k]=listQuery[k]
            }
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                })
                .then(function (response) {
                    var res = JSON.parse(JSON.stringify(response.data));
                    var arr=res.items
                    for(var ele of arr){
                        ele['time_str']=getTime(ele['time'])
                    }
                    //do table
                    _this.feedback_table_data.tableData = arr ;
                    _this.feedback_table_data.total = res.total ;
                })
                .catch(function (error) {
                    console.log(error);
                }).then(function(){ 
                    _this.feedback_table_data.loading=false;
                })
        },
        loadTaskFullData(listQuery) {
            var status_info={0:'upload',1:'submit',2:'running',3:'fail',4:'success',5:'trans file fail',6:'mongodb op fail'};
            var _this = this
            _this.task_table_data.loading=true;
            var para = {
                'action': 'get_task',
                'admin':_this.pw,
            }
            for(var k in listQuery){
                para[k]=listQuery[k]
            }
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                })
                .then(function (response) {
                    var res = JSON.parse(JSON.stringify(response.data));
                    var arr=res.items
                    for(var ele of arr){
                        ele['time_str']=getTime(ele['submit_time'])
                        ele['status']=status_info[ele['status']]
                        ele['task_id_raw']=ele['task_id']
                        ele['task_id']='<a target="_blank" href="#/results/phenotype_task?task_id='+ele['task_id']+'">'+ele['task_id']+'</a>'
                    }
                    //do table
                    _this.task_table_data.tableData = arr ;
                    _this.task_table_data.total = res.total ;
                })
                .catch(function (error) {
                    console.log(error);
                }).then(function(){ 
                    _this.task_table_data.loading=false;
                })
        },
        loadCommonTaskFullData(listQuery) {
            var status_info={0:'upload',1:'submit',2:'running',3:'fail',4:'success',5:'trans file fail',6:'mongodb op fail'};
            var _this = this
            _this.common_task_table_data.loading=true;
            var para = {
                'action': 'get_common_task',
                'admin':_this.pw,
            }
            for(var k in listQuery){
                para[k]=listQuery[k]
            }
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                })
                .then(function (response) {
                    var res = JSON.parse(JSON.stringify(response.data));
                    var arr=res.items
                    for(var ele of arr){
                        ele['time_str']=getTime(ele['submit_time'])
                        ele['status']=status_info[ele['status']]
                        ele['task_id_raw']=ele['task_id']
                        if(ele['func']=='emic'){
                            ele['task_id']='<a target="_blank" href="#/results/common_task_emic?task_id='+ele['task_id']+'">'+ele['task_id']+'</a>'
                        }
                        if(ele['func']=='gec'){
                            ele['task_id']='<a target="_blank" href="https://pmglab.top/gec/#/result?task_id='+ele['task_id']+'">'+ele['task_id']+'</a>'
                        }
                    }
                    //do table
                    _this.common_task_table_data.tableData = arr ;
                    _this.common_task_table_data.total = res.total ;
                })
                .catch(function (error) {
                    console.log(error);
                }).then(function(){ 
                    _this.common_task_table_data.loading=false;
                })
        },
    }
}
</script>

<style scoped>
.main {
    text-align: center;
    padding: 2vw 2vh;
}
.table-title{
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 10px;
}
.row{
    margin: 30px auto;
}
.table{
    text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/views/admin/index.vue